export default __webpack_public_path__ + "static/media/hlthtek_login.5bcda83b.jpg";